import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  subtitle: string;
  icon: React.ReactNode;
  iconBgColor: string;
  iconColor: string;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  iconBgColor,
  iconColor,
  onClick,
}) => {
  return (
    <div className="rounded-xl border border-[#F2F4F7] bg-white p-6 shadow-[0_4px_12px_0_rgba(249,250,251,1)] hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-semibold text-gray-600">{title}</p>
          <p className="mt-3 text-4xl font-bold text-gray-900">{value}</p>
          <button 
            onClick={onClick}
            className="mt-3 text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline cursor-pointer"
          >
            {subtitle}
          </button>
        </div>
        <div className={`rounded-full ${iconBgColor} p-3`}>
          <div className={iconColor}>{icon}</div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
